import React, { useState,useEffect } from "react";
import { FaQuestionCircle } from "react-icons/fa";
import { Tooltip, Button, notification } from "antd";
import { Spin } from 'antd';
import axios from 'axios'
import { encryptPayload, decryptData } from "../encryption/AesEncryption";
import { useTab } from "../../context/TabContext";


export default function Authentication() {
  const { setActiveTab } = useTab();


  const [api, contextHolder] = notification.useNotification();

  const [formData, setFormData] = useState({
    sourceUrl: "",
    sourceApiKey: "",
    sourceEmail: "",
    destinationUrl: "",
    destinationApiKey: "",
    destinationEmail: "",
    source: "",
    destination: "",
  });


    useEffect(() => {
      const fetchData = async () => {
       // activateLoader();
        //console.log("SDSD ");
  
        const sourceData = await getCountData();
  
        setFormData((prevCount) => ({
          ...prevCount,
          sourceUrl: sourceData.sourceUrl,
          sourceApiKey: sourceData.sourceApiKey,
          sourceEmail: sourceData.sourceEmail,
          destinationUrl: sourceData.destinationUrl,
          destinationApiKey: sourceData.destinationApiKey,
          destinationEmail: sourceData.destinationEmail,
          source: sourceData.source,
          destination: sourceData.destination,
        }));
  
       // console.log("SDSD* ");
        //deactivateLoader();
      };
  
      fetchData();
    }, []);


      const getCountData = async () => {
        const countApiUrl = process.env.REACT_APP_MIGRATIONDETAIL_API;
        console.log("sfd ", countApiUrl);
        const clienId = localStorage.getItem("clientId");
        const migrationId = localStorage.getItem("migrationId");
        const accessToken = localStorage.getItem("accessToken");
        console.log("clientId",clienId);
        console.log("migrationId",migrationId);
       if(clienId !==null &&migrationId !==null){
        const payload = {
          clienId: localStorage.getItem("clientId"),
          migrationId: localStorage.getItem("migrationId"),
        };
        console.log("PAYLOAD ", payload);

        const MigrationDetailResponse = await axios.post(countApiUrl, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        console.log("SDS ", MigrationDetailResponse);
        if (MigrationDetailResponse) {
          const MigrationData = await MigrationDetailResponse.data;
    
          if (MigrationData.status === 200) {
            console.log("DATA ", MigrationData.data);
            const encryptedPayload = MigrationData.data;
            
            

            console.log("encrypted Payload",encryptedPayload);

            const  sourceApiKey = decryptData(encryptedPayload.encryptsourceApiKey) ;
            const  sourceUrl = decryptData(encryptedPayload.encryptsourceUrl) ;
            const  sourceEmail = decryptData(encryptedPayload.encryptsourceEmail );
            const  source = decryptData(encryptedPayload.encryptsource) ;
            const  destinationApiKey = decryptData(encryptedPayload.encryptdestinationApiKey) ;
            const  destinationUrl = decryptData(encryptedPayload.encryptdestinationUrl );
            const  destinationEmail = decryptData(encryptedPayload.encryptdestinationEmail) ;
            const  destination = decryptData(encryptedPayload.encryptdestination) ;

            console.log("Decrypted data:", {
              sourceApiKey,
              sourceUrl,
              sourceEmail,
              source,
              destinationApiKey,
              destinationUrl,
              destinationEmail,
              destination,
            });
            

            return {
              sourceUrl: sourceUrl,
              sourceApiKey: sourceApiKey,
              sourceEmail: sourceEmail,
              destinationUrl:destinationUrl,
              destinationApiKey:destinationApiKey,
              destinationEmail:destinationEmail,
              source:source,
              destination:destination,
            };

          } else {
            return {
              sourceUrl: "",
              sourceApiKey: "",
              sourceEmail: "",
              destinationUrl: "",
              destinationApiKey: "",
              destinationEmail: "",
              source:"",
              destination:"",
            };
          }
        }
       }
      else{
        return {
          sourceUrl: "",
          sourceApiKey: "",
          sourceEmail: "",
          destinationUrl: "",
          destinationApiKey: "",
          destinationEmail: "",
          source:"",
          destination:"",
        };
      }

      };

  const connectionNotification = (type, text) => {
    api[type]({
      message: text,
    });
  };




  const [isConnected, setIsConnected] = useState(false);
  const [isconnectLoader,setConnectLoader] = useState(false);
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[a-zA-Z]{2,}$/;
console.log("FormData",formData);
// console.log("active Tab",activeTab);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleConnect = async () => {
    console.log("The handle connect get called")
    setConnectLoader(true);

    console.log("SRC ",formData.sourceEmail)
    const sourceEmailValidation  = emailRegex.test(formData.sourceEmail);
    console.log("SRC ",sourceEmailValidation)
    console.log("DES ",formData.destinationEmail)
    const destinationEmailValidation  = emailRegex.test(formData.destinationEmail);
    console.log("DES ",destinationEmailValidation)

    if(!((formData.sourceUrl.endsWith('.zendesk.com') || formData.sourceUrl.endsWith('.zendesk.com/'))&& formData.sourceUrl.startsWith("https://")) || (!sourceEmailValidation)){
      if(!((formData.sourceUrl.endsWith('.zendesk.com') || formData.sourceUrl.endsWith('.zendesk.com/'))&& formData.sourceUrl.startsWith("https://")) && (!sourceEmailValidation)){
        connectionNotification(
          "error",
          "Invalid Zendesk URL and Email Formats"
        );
      }
      else if(!((formData.sourceUrl.endsWith('.zendesk.com') || formData.sourceUrl.endsWith('.zendesk.com/'))&& formData.sourceUrl.startsWith("https://"))){
        connectionNotification(
          "error",
          "Invalid Zendesk URL Format"
        );
      }
      else if (!sourceEmailValidation) {
        connectionNotification(
          "error",
          "Invalid Zendesk Email Format"
        );
      }
      setConnectLoader(false);
    }

    
    if(!((formData.destinationUrl.endsWith('.freshdesk.com') || formData.destinationUrl.endsWith('.freshdesk.com/'))&& formData.destinationUrl.startsWith("https://")) || (!destinationEmailValidation)){
      if(!((formData.destinationUrl.endsWith('.freshdesk.com') || formData.destinationUrl.endsWith('.freshdesk.com/'))&& formData.destinationUrl.startsWith("https://")) && (!destinationEmailValidation)){
        connectionNotification(
          "error",
          "Invalid Freshdesk URL and Email Formats"
        );
      }
      else if(!((formData.destinationUrl.endsWith('.freshdesk.com') || formData.destinationUrl.endsWith('.freshdesk.com/'))&& formData.destinationUrl.startsWith("https://"))){
        connectionNotification(
          "error",
          "Invalid Freshdesk URL Format"
        );
      }
      else if (!destinationEmailValidation) {
        connectionNotification(
          "error",
          "Invalid Freshdesk Email Format"
        );
      }
      setConnectLoader(false);
    }

    else{
      const payload = {
        clientId: localStorage.getItem("clientId"),
        sourceUrl: formData.sourceUrl,
        sourceApiKey: formData.sourceApiKey,
        sourceEmail: formData.sourceEmail,
        destinationUrl: formData.destinationUrl,
        destinationApiKey: formData.destinationApiKey,
        destinationEmail: formData.destinationEmail,
        source: formData.source,
        destination: formData.destination,
      };
      console.log("The Payload",payload);

      localStorage.setItem("source",formData.source);
      localStorage.setItem("destination",formData.destination);
      localStorage.setItem("destinationUrl",formData.destinationUrl);
      const encyptedPayload = await encryptPayload(payload);
     
      console.log("THe encrypted payload",encyptedPayload);
      const apiUrl = process.env.REACT_APP_REG_API;
      

      const accessToken = localStorage.getItem("accessToken");

      try {
        const response = await axios.post(apiUrl,encyptedPayload,{
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          }
        });
  
        if (response) {
          
          const responseData = await response.data;
  
          if(responseData.status === 201 || responseData.status === 409){
            localStorage.setItem('migrationId',responseData.migrationId)
            connectionNotification(
              "success",
              "Connection Established Successfully"
            );
            setConnectLoader(false);
            setIsConnected(true);
            setTimeout(()=>{
              setActiveTab("3");
            },1000)
            
          }
  
          else if(responseData.status === 401){
            const statusData = responseData.data
  
  
            if(statusData.zdk_status_code !== 200 && statusData.fdk_status_code !== 200){
              connectionNotification(
                "error",
                "Invalid Zendesk and Freshdesk Credentials"
              );
              setConnectLoader(false);
              setIsConnected(false);
            }
            else if(statusData.zdk_status_code !== 200 ){
              connectionNotification(
                "error",
                "Invalid Zendesk Credentials"
              );
              setConnectLoader(false);
              setIsConnected(false);
            }
            else if(statusData.fdk_status_code !== 200){
              connectionNotification(
                "error",
                "Invalid Freshdesk Credentials"
              );
              setConnectLoader(false);
              setIsConnected(false);
            }
  
          }
          else if(responseData.status === 500){
            connectionNotification(
              "error",
              "Error Occured at API"
            );
            setConnectLoader(false);
            setIsConnected(false);
          }
          
          
  
        } else {
          // Handle error response
          console.error("Error from API:", response.statusText);
          connectionNotification("error", "Connection Failed");
          setConnectLoader(false);
          setIsConnected(false);
        }
      } catch (error) {
        console.error("Error during API call:", error);
        connectionNotification("error", "Connection Failed");
        setConnectLoader(false);
        setIsConnected(false);
      }
    };
  

  }

    
  // Check if all fields are filled to enable "Connect" button
  const isFormValid = Object.values(formData).every((value) => value !== "");

  return (
    <>
      {contextHolder}
      <div className="grid grid-cols-2">
        <div style={{ borderRight: "1.5px dashed #ddd" }}>
          <p className="head-para">SOURCE</p>
          <div className="mt-1 flex items-center gap-2">
            <select
              className="w-[200px] text-[22px] rounded-[5px] h-[45px] font-[600] text-[#484848]"
              style={{ padding: "2px 10px 4px", border: "2px solid #ddd" }}
              name="source"
              value={formData.source}
              onChange={handleInputChange}
            >
              <option value="" className="text-[14px]">
                Select
              </option>
              <option value="Zendesk" className="text-[14px]">
                Zendesk
              </option>
            </select>
            <img src="/images/zendesk.svg" className="w-[8.5rem]" />
          </div>
          <div className="mt-3">
            <label className="text-[13px]">URL</label>
            <div className="flex items-center gap-2">
              <input
                className="w-[90%]"
                name="sourceUrl"
                value={formData.sourceUrl}
                onChange={handleInputChange}
                placeholder="https://domain.zendesk.com/"
              />
              <Tooltip placement="top" title="Enter your zendesk url here">
                <FaQuestionCircle className="text-[#7c7c7c] text-[14px]" />
              </Tooltip>
            </div>
          </div>
          <div className="mt-3">
            <label className="text-[13px]">API KEY</label>
            <div className="flex items-center gap-2">
              <input
                className="w-[90%]"
                name="sourceApiKey"
                value={formData.sourceApiKey}
                onChange={handleInputChange}
                placeholder="8j5Tqb5kFeqIE972khi"
              />
              <Tooltip placement="top" title="Enter your zendesk api key here">
                <FaQuestionCircle className="text-[#7c7c7c] text-[14px]" />
              </Tooltip>
            </div>
          </div>
          <div className="mt-3">
            <label className="text-[13px]">Email</label>
            <input
              className="w-[96%]"
              name="sourceEmail"
              value={formData.sourceEmail}
              onChange={handleInputChange}
              placeholder="zzz@gmail.com"
            />
          </div>
        </div>
        <div className="pl-[25px]">
          <p className="head-para">DESTINATION</p>
          <div className="mt-1 flex items-center gap-2">
            <select
              className="w-[200px] text-[22px] rounded-[5px] h-[45px] font-[600] text-[#484848]"
              style={{ padding: "2px 10px 4px", border: "2px solid #ddd" }}
              name="destination"
              value={formData.destination}
              onChange={handleInputChange}
            >
              <option value="" className="text-[14px]">
                Select
              </option>
              <option value="Freshdesk" className="text-[14px]">
                Freshdesk
              </option>
            </select>
            <img src="/images/freshdesk.svg" className="w-[8.5rem]" />
          </div>
          <div className="mt-3">
            <label className="text-[13px]">URL</label>
            <div className="flex items-center gap-2">
              <input
                className="w-[90%]"
                name="destinationUrl"
                value={formData.destinationUrl}
                onChange={handleInputChange}
                placeholder="https://domain.freshdesk.com/"
              />
              <Tooltip placement="top" title="Enter your freshdesk url here">
                <FaQuestionCircle className="text-[#7c7c7c] text-[14px]" />
              </Tooltip>
            </div>
          </div>
          <div className="mt-3">
            <label className="text-[13px]">API KEY</label>
            <div className="flex items-center gap-2">
              <input
                className="w-[90%]"
                name="destinationApiKey"
                value={formData.destinationApiKey}
                onChange={handleInputChange}
                placeholder="8j5Tqb5kFeqIE972khi"
              />
              <Tooltip
                placement="top"
                title="Enter your freshdesk api key here"
              >
                <FaQuestionCircle className="text-[#7c7c7c] text-[14px]" />
              </Tooltip>
            </div>
          </div>
          <div className="mt-3">
            <label className="text-[13px]">Email</label>
            <input
              className="w-[96%]"
              name="destinationEmail"
              value={formData.destinationEmail}
              onChange={handleInputChange}
              placeholder="zzz@gmail.com"
            />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center gap-4 mt-10">
      <button
          className={`custom-btn ${
            isConnected ? "connected-btn" : !isFormValid && "disabled-btn"
          }`}
          onClick={handleConnect}
          disabled={!isFormValid || isconnectLoader || isConnected} // Disable if connected
          style={{
            backgroundColor: isConnected ? "green" : "",
            color: isConnected ? "white" : "",
            opacity: isconnectLoader || !isFormValid ? 0.7 : 1,
            position: "relative",
            pointerEvents: isconnectLoader ? "none" : "auto"
          }}>
          {isconnectLoader ? (
            <div className="flex items-center justify-center gap-2">
              <span>Connecting</span>
              <Spin />
            </div>
          ) : isConnected ? (
            "Connected"
          ) : (
            "Connect"
          )}
      </button>
      </div>
    </>
  );
}
